import React from 'react';

import { Alert, AlertDescription } from '@zapier/design-system';

import Link from 'app/common/components/Link';

import { Status } from 'app/zap-templates/types';

const msgs = {
  '': {
    msg: 'You haven’t added any Zap templates yet.',
    link: {
      text: 'Learn how to get started with Zap templates.',
      href: 'https://docs.zapier.com/platform/publish/zap-templates',
    },
  },
  [Status.draft]: {
    msg: 'You haven’t added any Drafts yet.',
    link: {
      text: 'Learn how to get started with Zap templates.',
      href: 'https://docs.zapier.com/platform/publish/zap-templates',
    },
  },
  [Status.forReview]: {
    msg: 'You have no Zap templates in review.',
    link: {
      text: 'Learn how to submit your Zap templates for review.',
      href:
        'https://docs.zapier.com/platform/publish/zap-templates#5-submit-zap-template-for-review',
    },
  },
  [Status.invalid]: {
    msg: 'There are no invalid Zap templates yet.',
    link: {
      text:
        'These templates have become invalid. To fix the Zap templates review each step on the Zap template.',
      href: 'https://docs.zapier.com/platform/publish/zap-templates',
    },
  },
  [Status.rejected]: {
    msg: 'You have no rejected Zap templates!',
    link: null,
  },
  [Status.published]: {
    msg: 'You haven’t made any Zap templates public yet.',
    link: {
      text: 'Learn how to make your Zap templates public.',
      href:
        'https://docs.zapier.com/platform/publish/zap-templates#5-submit-zap-template-for-review',
    },
  },
};

type Props = {
  status: Status | undefined;
};

const defaultProps = { status: '' };

function NoTemplates({ status }: Props) {
  return (
    <Alert title={msgs[status].msg}>
      {msgs[status]?.link && (
        <AlertDescription>
          <Link href={msgs[status].link.href} target="_blank">
            {msgs[status].link.text}
          </Link>
        </AlertDescription>
      )}
    </Alert>
  );
}

NoTemplates.defaultProps = defaultProps;

export default NoTemplates;
